import { Outlet, RouteObject } from 'react-router-dom';
import { ShipperProfileScreen } from './ShipperProfileScreen';
import {
  ShipperReportConfirmationScreen,
  ShipperReportingFormScreen,
  ShipperReportingReasonSelectorScreen,
} from './ShipperReportingScreen';

export const shipperProfileMobileRoutes: RouteObject[] = [
  {
    path: 'shipper-report/*',
    element: <Outlet />,
    children: [
      { path: ':reason/report-form', element: <ShipperReportingFormScreen /> },
      { path: 'confirmation', element: <ShipperReportConfirmationScreen /> },
      { path: '*', element: <ShipperReportingReasonSelectorScreen /> },
    ],
  },
  { path: '*', element: <ShipperProfileScreen /> },
];
